import { useEffect, useState } from "react";
import { SidebarWidgetStyled } from "./styled";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { RENDER_ROUTE_PERMISSION } from "utils/functions/config";
import { portalService } from "apiServices";
import { Icons } from "components";

const SidebarWidget = ({ collapsed }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const authenRedux = useSelector((state) => state.authenRedux);

  const [_active, _setActive] = useState();
  const [_isAlert, _setIsAlert] = useState(false);

  useEffect(() => {
    if (location) {
      const splitPathname = location.pathname.split("/");
      _setActive(splitPathname[2]);
    }
    _fetchNoti();
  }, [location]);

  const _fetchNoti = async () => {
    let res = await portalService.GET_ACTIVITY_FORM_ALERT();
    if (res && res.staus === 200) {
      _setIsAlert(true);
    } else {
      _setIsAlert(false);
    }
  };

  const _handleClickMenu = (e) => {
    navigate(e.path);
  };

  return (
    <SidebarWidgetStyled $collapsed={collapsed}>
      <div className="s_logo_sec">
        <img
          className="sidebar_logo"
          alt="MiSUMi logo"
          src={
            collapsed
              ? "/assets/images/logos/logo_short.png"
              : "/assets/images/logos/logo.png"
          }
        />
      </div>
      <ul className="s_menu_sec">
        {authenRedux &&
          RENDER_ROUTE_PERMISSION(authenRedux?.permission)
            .filter((f) => !f.notShowSidebar)
            .map((e, i) => (
              <li
                key={i}
                className={`s_menu_item ${_active === e.key ? "active" : ""}`}
                onClick={() => _handleClickMenu(e)}
              >
                <span className="s_menu_icon">
                  {e.icon && e.icon(_active === e.key ? true : false)}
                  {_isAlert && e.key === "activity-form" && (
                    <span className="s_menu_alert_dot" />
                  )}
                </span>
                <span className="s_menu_label">{e.name}</span>
                {_isAlert && e.key === "activity-form" && !collapsed && (
                  <Icons.BellIcon width="22" height="22" />
                )}
                {collapsed && <span className="s_menu_tooltip">{e.name}</span>}
              </li>
            ))}
      </ul>
    </SidebarWidgetStyled>
  );
};

export default SidebarWidget;
